<template>
  <div
    v-loading="pageLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="text-muted mb-1" style="font-size:16px;">
      订单编号: {{ dispatchOrderNo }}
    </div>
    <page-header
      ref="header"
      slot="header"
      :dispatchOrderNo="dispatchOrderNo"
      :driveNo="driveNo"
      @driveChange="onDriveChange"
      @query="getData"
      @reset="resetPage"
    />

    <div>
      <page-toolbar
        :mode.sync="mode"
        @pdfExport="pdfExport"
        @excelExport="excelExport"
        @excelImport="excelImport"
      />
      <div class="data_body" :style="`height:${tableHeight - 100}px;`">
        <page-main
          class="data_item table"
          :class="{
            show: mode === 'table',
          }"
          :tableData="tableData"
          :columns="tableColumns"
          :loading="loading"
          :tablePage="page"
          @reload="reload"
        >
        </page-main>
        <div
          class="data_item chart"
          :class="{
            show: mode === 'chart',
          }"
        >
          <page-chart :options="chartData" ref="pageChart" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import PageToolbar from './toolbar'
import BaseTable from '@/mixins/base-table'
import PageChart from './chart'
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  components: {
    PageHeader,
    PageToolbar,
    PageMain,
    PageChart,
  },
  mixins: [BaseTable, TableAutoHeight],
  props: {
    dispatchOrderNo: String,
    driveNo: String,
  },
  data() {
    return {
      mode: 'table',
      drive: {},
      pageLoading: false,
    }
  },
  computed: {
    tableColumns() {
      return tableColumns(this.drive.driveType)
    },
    chartData() {
      const types = {
        temp: '温度',
        hum: '湿度',
      }
      const data = [...this.tableData]
      const xAxis = data.reverse().map((item) => item.reportTime)
      const series = data.reverse().reduce((all, item) => {
        const reg = `^(temp|hum)${item.recordType === 'V' ? '(\\d+)' : '$'}`
        Object.keys(item)
          .filter((key) => key.match(reg))
          .forEach((key) => {
            const [, type, num] = key.match(reg)
            const name = `${types[type]}${num || ''}`
            if (all[name]) {
              all[name].push(item[key])
            } else {
              all[name] = [item[key]]
            }
          })
        return all
      }, {})
      return {
        xAxis,
        series: Object.entries(series).map(([k, v]) => ({ name: k, data: v })),
      }
    },
  },
  methods: {
    async getData(form) {
      if (!this.dispatchOrderNo) return
      this.loading = true
      await this.$api
        .waybillTempListByDispatchOrderNoAndDriveNo({
          dispatchOrderNo: this.dispatchOrderNo,
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    onDriveChange(val) {
      this.drive = val
    },
    async pdfExport() {
      const { driveNo, driveType } = this.drive
      if (!driveNo) {
        this.$message({
          message: '请先选择一个设备，再进行导出！',
          type: 'warning',
        })
        return
      }

      this.pageLoading = true
      const form = this.$refs.header.getForm()
      await this.getData(form)

      setTimeout(async () => {
        const imageBase64 = this.$refs.pageChart.getImagesBase64()
        const params = {
          ...form,
          dispatchOrderNo: this.dispatchOrderNo,
          driveType,
          imageBase64,
        }
        const url = '/order/temp/report/export/pdf'
        const fileName = `${this.dispatchOrderNo} - ${driveNo} 温度上报记录`
        await this.$api.exportBlobFile(url, fileName, {
          method: 'post',
          data: params,
        })
        this.pageLoading = false
      }, 0)
    },
    async excelExport() {
      const { driveNo, driveType } = this.drive
      if (!driveNo) {
        this.$message({
          message: '请先选择一个设备，再进行导出！',
          type: 'warning',
        })
        return
      }

      const form = this.$refs.header.getForm()
      const params = {
        ...form,
        dispatchOrderNo: this.dispatchOrderNo,
        driveType,
      }
      const url = '/order/temp/report/export/excel'
      const fileName = `${this.dispatchOrderNo} - ${driveNo} 温度上报记录`
      this.pageLoading = true
      await this.$api.exportBlobFile(url, fileName, {
        method: 'post',
        data: params,
      })
      this.pageLoading = false
    },
    async excelImport(file) {
      this.pageLoading = true
      await this.$api
        .excelImportTempReport(file)
        .then((res) => {
          this.pageLoading = false
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$refs.header.query()
        })
        .catch(() => {
          this.pageLoading = false
        })
    },
  },
}
</script>
<style scoped>
.data_body {
  position: relative;
  min-height: 680px;
}
.data_body .data_item {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.data_body .data_item.table {
  display: none;
  z-index: 1001;
}
.data_body .data_item.chart {
  z-index: 1000;
  width: 100%;
}
.data_body .data_item.table.show {
  display: block;
}
.data_body .data_item.chart.show {
  z-index: 1002;
}
</style>
